import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { selectSpecialistRoleToWork } from "../../app/actions/userRoleActions";
import useActiveSpecialistRole from "../../app/hooks/useActiveSpecialistRole";

const useFeederTrayRoleSync = ({ enabled = true } = {}) => {
  const dispatch = useDispatch();
  const { availableRoles, selectedRole } = useActiveSpecialistRole();
  const syncedRef = useRef(false);

  useEffect(() => {
    if (!enabled || syncedRef.current || !availableRoles.length) {
      return;
    }
    if (selectedRole?.roleKey === "coordinator") {
      syncedRef.current = true;
      return;
    }
    const match = availableRoles.find((role) => role.roleKey === "feeder");
    if (!match) {
      return;
    }
    syncedRef.current = true;
    if (Number(selectedRole?.id) === Number(match.id)) {
      return;
    }
    dispatch(selectSpecialistRoleToWork(match));
  }, [availableRoles, dispatch, enabled, selectedRole]);
};

export default useFeederTrayRoleSync;
